import type { NextPage } from "next";
import { WrapOnlyV2 } from "@components/WrapOnly";

const WrapPage: NextPage = () => {
  return <WrapOnlyV2 />;
};

export default WrapPage;
